import { Outlet } from 'react-router-dom';

import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary.tsx';
import { ToolkitGenericFallback } from '../../components/ToolkitGenericFallback.tsx';
import { ModuleContextProvider } from '../ModuleContextProvider.tsx';
import { StudiesContext } from '../consts.ts';
import { useNewStudiesState } from '../hooks/useNewStudiesState.ts';

export const RootStudiesElement = () => {
  const studiesContext = useNewStudiesState();

  return (
    <ModuleContextProvider expectOrder={false}>
      <ErrorBoundary Fallback={ToolkitGenericFallback}>
        <StudiesContext.Provider value={studiesContext}>
          {studiesContext.studies.isLoading ? null : <Outlet />}
        </StudiesContext.Provider>
      </ErrorBoundary>
    </ModuleContextProvider>
  );
};
